<template>
  <div class="dialog-pdf-to-image" :style="{visibility: state.visibility ? 'visible' : 'hidden'}">
    <div v-if="state.pdf != null" class="dialog-pdf-to-image-body">
      <div class="dialog-pdf-to-image-body-header">
        Select PDF Page
      </div>
      <div class="dialog-pdf-to-image-body-content">
        <dialog-pdfto-image-thumb v-for="(img, i) in state.pdf.numPages"
          :key="`${i}`"
          :pdf="state.pdf"
          :index="i"
          :selected-index="state.selectedItem.index"
          @onselect="listen__thumb__onselect"/>
      </div>
      <div class="dialog-pdf-to-image-body-footer">
        <div style="display:flex;flex-direction:row;align-items:center;">
          <div v-show='state.selectedItem.index != null' style="display:flex;flex-direction:row;align-items:center;">
            <span style="font-size:14px;margin-right:3px;">resolution</span>
            <input ref="input-scale" type="range" min="0" max="100" step="0.1" style="width:100px;" @input="listen__scale__onchange" />
          </div>
          <div v-show='state.selectedItem.index != null' style="display:flex;flex-direction:row;align-items:center;margin:0px 15px 0px 10px;">
            <span style="font-size: 12px;color:gray">{{ `${state.selectedItem.width} x ${state.selectedItem.height}` }}</span>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;align-items:center;float:right">
          <q-btn-group>
            <q-btn color="primary" label="confirm" size="xs" @click="listen__confirm__onclick" />
            <q-btn color="red" label="cancel" size="xs" @click="listen__cancel__onclick" />
          </q-btn-group>
        </div>
      </div>
      <div v-show="state.loading" class="loading">
        <q-spinner
          color="primary"
          size="3em"
        />
        <span style="margin-top:10px;">image로 변환 중 입니다.</span>
      </div>
    </div>
    <div v-else>
      <q-spinner
          color="primary"
          size="1em"
        />
        <span style="margin-left:5px;">pdf를 읽는 중 입니다.</span>
    </div>
  </div>
</template>

<script>
import MISC from '@/js/miscellaneous.js'
import dialogPdftoImageThumb from './dialogPdftoImageThumb.vue'

const pdfjsLib = require("@/pdfjs-webpack");

function toBlob (page, scale) {
  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas')
    let viewport = page.getViewport({scale: scale})
    canvas.width = viewport.width
    canvas.height = viewport.height

    let render_context = {
      canvasContext: canvas.getContext('2d'),
      viewport: viewport
    }
    try {
      page.render(render_context).promise.then(() => {
        canvas.toBlob((blob) => {  
          resolve(blob)
        }, "image/png", 1)
      })
    } catch (err) {
      console.log(err)
      reject()
    }
  })
}

export default {
  data: function () {
    return {
      state: {
        visibility: false,
        name: null,
        pdf: null,
        selectedItem: {
          index: null,
          width: null,
          height: null,
          width0: null,
          height0: null
        },
        doneCallback: null,
        loading: false
      },
      maxSize: 3 * 1000 * 1000, // 3 MB
      minSize: parseInt(0.02 * 1000 * 1000),
      initScale: 1.25
    }
  },
  components: {dialogPdftoImageThumb},
  methods: {
    listen__thumb__onselect: function (data) {
      const Vue = this
      Vue.state.selectedItem.index = data.index
      Vue.state.selectedItem.width0 = parseInt(data.width * Vue.initScale)
      Vue.state.selectedItem.height0 = parseInt(data.height * Vue.initScale)
      let inputScale = Vue.$refs['input-scale']
      let maxScale = Vue.maxSize / (data.width * data.height)
      let minScale = Vue.minSize / (data.width * data.height)
      let curScale = Math.max(minScale, Math.min(maxScale, 1))
      inputScale.min = minScale
      inputScale.max = maxScale
      inputScale.value = curScale
      Vue.listen__scale__onchange()
    },
    listen__scale__onchange: function () {
      const Vue = this
      let scale = Vue.$refs['input-scale'].value

      let size = Vue.state.selectedItem.width0 * Vue.state.selectedItem.height0 * scale
      let ar = Vue.state.selectedItem.width0 / Vue.state.selectedItem.height0
      
      let height = Math.sqrt(size / ar)
      let width = height * ar

      Vue.state.selectedItem.width = parseInt(height)
      Vue.state.selectedItem.height = parseInt(width)
    },
    listen__confirm__onclick: async function () {
      const Vue = this

      if (Vue.state.selectedItem.index == null) {
        Vue.$q.notify({
            message: "page를 선택하여 주세요.",
            icon: 'announcement',
            color: 'red'
          })
          return
      }

      if (Vue.state.selectedItem.width > 0 == false || Vue.state.selectedItem.height > 0 == false) {
        Vue.$q.notify({
            message: "width 또는 height는 0보다 커야 합니다.",
            icon: 'announcement',
            color: 'red'
          })
          return
      }

      if (Vue.state.doneCallback != null) {
        let png_name
        let tokens = Vue.state.name.split('.')
        if (tokens.length < 2)
          png_name = `${Vue.state.name}-page${Vue.state.selectedItem.index + 1}.png`
        else
          png_name = `${tokens.filter((v, i) => i != tokens.length - 1).join('')}-page${Vue.state.selectedItem.index + 1}.png`

        Vue.state.loading = true
        MISC.doubleRaf(async () => {
          let page = await Vue.state.pdf.getPage(Vue.state.selectedItem.index + 1)
          let blob = await toBlob(page, Vue.$refs['input-scale'].value)
          Vue.state.loading = false

          let file = new File([blob], png_name)
          Vue.state.doneCallback({
            success: true,
            file
          })
          Vue.close()
        })
      } else
        Vue.close()
    },
    listen__cancel__onclick: function () {
      const Vue = this
      if (Vue.state.doneCallback != null) {
        Vue.state.doneCallback({
          success: false
        })
      }
      Vue.close()
    },
    show: function (file, doneCallback) {
      const Vue = this
      Vue.state.visibility = true
      MISC.doubleRaf(async() => {
        Vue.state.name = file.name
        let pdfBinary = await file.arrayBuffer()
        let pdfTask = await pdfjsLib.getDocument({ data: pdfBinary });
        let pdf
        try {
          pdf = await pdfTask.promise
          Vue.state.pdf = pdf
          Vue.state.doneCallback = doneCallback
        } catch (err) {
          doneCallback({
            success: false
          })
          Vue.close()
        }
      })
    },
    close: function () {
      const Vue = this
      Vue.state.visibility = false
      Vue.state.name = null
      Vue.state.pdf = null
      Vue.state.selectedItem.index = null
      Vue.state.selectedItem.width = null
      Vue.state.selectedItem.height = null
      Vue.state.doneCallback = null
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>
div.dialog-pdf-to-image {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9499;
}

div.dialog-pdf-to-image-body {
  position: relative;
  display: flex;
  flex-direction: column;
  background: white;
  max-width: 80%;
  max-height: 80%;
  border-radius: 3px;
}

div.dialog-pdf-to-image-body > .loading {
  position:absolute;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
}

div.dialog-pdf-to-image-body-header {
  font-size: 18px;
  font-weight: bold;
  height: 40px;
  padding: 5px 0px 0px 15px;
  border-bottom: 1px solid rgb(230, 230, 230);
}

div.dialog-pdf-to-image-body-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin: 10px;
  overflow: auto;
}

div.dialog-pdf-to-image-body-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 40px;
  padding: 0px 15px 0px 15px;
  border-top: 1px solid rgb(230, 230, 230);
}
</style>